export enum VideoType {
  Error = "error",
  Vimeo = "vimeo",
  YouTube = "youtube"
}

interface VideoOutput {
  type: VideoType,
  url?: string
}

const convertVideoUrlToEmbedUrl = (videoUrl: string): VideoOutput | null => {
  if (!videoUrl) {
    return null
  }

  const youTubeRegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\\&v=)([^#\\&\\?]*).*/
  const youtubeMatch = videoUrl.match(youTubeRegExp)
  const youtubeEmbedUrl = "https://www.youtube.com/embed/"

  if (youtubeMatch && youtubeMatch[2]) {
    return {
      type: VideoType.YouTube,
      url: `${youtubeEmbedUrl}${youtubeMatch[2]}`
    }
  }

  const vimeoRegExp = /(http|https)?:\/\/(player\.|www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)(\d+)(?:|\/\?)/
  const vimeoMatch = videoUrl.match(vimeoRegExp)
  const vimeoEmbedUrl = "https://player.vimeo.com/video/"

  if (vimeoMatch && vimeoMatch[4]) {
    return {
      type: VideoType.Vimeo,
      url: `${vimeoEmbedUrl}${vimeoMatch[4]}`
    }
  }

  return {
    type: VideoType.Error
  }
}

export default convertVideoUrlToEmbedUrl
